import { render } from "./ElectricBikeServices.vue?vue&type=template&id=23e0db2a&scoped=true"
import script from "./ElectricBikeServices.vue?vue&type=script&lang=js"
export * from "./ElectricBikeServices.vue?vue&type=script&lang=js"

import "./ElectricBikeServices.vue?vue&type=style&index=0&id=23e0db2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23e0db2a"]])

export default __exports__